import React, { useState, useEffect, useRef } from "react";
import "./weighing-control.css";
import Header from "../../components/header/Header";
import NoCheckIcon from "../../../../../assets/imgs/amc-domestico/NoGen.svg";
import GenIcon from "../../../../../assets/imgs/amc-domestico/gen.svg";
import axios from "axios";
import * as XLSX from "xlsx";
import { useForm } from "react-hook-form";
import Overlay from "react-bootstrap/Overlay";
import { FaFileExport, FaSpinner } from "react-icons/fa";
import { hiddenMedalliaButton } from "../../components/hidemedallia";
import { FaX } from "react-icons/fa6";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";

function WeighingControl() {
  const [shipments, setShipments] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [descriptions, setDescriptions] = useState({});
  const [isFiltering, setIsFiltering] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [alertDays, setAlertDays] = useState(false);
  const [loaderModal, setLoaderModal] = useState(false);
  const [showOverlay, setShowOverlay] = useState({
    turn: false,
    start: false,
    end: false,
  });
  const [formValues, setFormValues] = useState({
    start: "",
    end: "",
    turn: "",
    awb: "",
  });

  const containerRef = useRef(null);
  const turnRef = useRef(null);
  const startRef = useRef(null);
  const endRef = useRef(null);

  useEffect(() => {
    const cleanMedallia = hiddenMedalliaButton();
    return cleanMedallia;
  }, []);

  const {
    register: register,
    handleSubmit: handleSubmitForm1,
    watch,
    reset: reset,
    setError,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true });
  const turn = watch("turn");
  const start = watch("start");
  const end = watch("end");

  const {
    register: registerForm2,
    handleSubmit: handleSubmitForm2,
    reset: resetForm2,
    formState: { errors: errorsForm2 },
  } = useForm({ mode: "onChange", shouldFocusError: true });

  const onSubmit = async (data) => {
    setIsFiltering(true);
    if (new Date(data.start) > new Date(data.end)) {
      setError("start", {
        type: "manual",
        message: "La fecha de inicio no puede ser mayor que la de fin",
      });
      return;
    }

    const dateStart = formatDate(data.start);
    const dateEnd = formatDate(data.end);

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard?startDate=${dateStart}&finishDate=${dateEnd}&turn=${data.turn}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setShipments(res.data.shipments || []);
        setHasMore(false);
      }
    } catch (error) {
      setIsFiltering(false);
      console.error(error);
    }
  };

  function formatDate(dateISO) {
    const [year, month, day] = dateISO.split("-");
    return `${day}/${month}/${year}`;
  }

  const clearFilters = async () => {
    setIsFiltering(false);
    reset({
      start: "",
      end: "",
      turn: "",
    });
    setPage(1);
    setHasMore(true);
    setShipments([]);
    await getData();
  };

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = containerRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 1 && hasMore) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const getData = async () => {
    setIsFiltering(false);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard?page=${page}&limit=10`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        if (res.data.shipments.length > 0) {
          setShipments((prevData) => [...prevData, ...res.data.shipments]);
        } else {
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "Etiqueta emitida";
      case 2:
        return "Pesaje";
      case 3:
        return "Documentando";
      case 4:
        return "Finalizado";
      case 5:
        return "Cancelado Pesador";
      case 6:
        return "Cancelado Mostrador";
      default:
        return "";
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 1:
        return "validated";
      case 2:
        return "in-process";
      case 3:
        return "documenting";
      case 4:
        return "approved";
      case 5:
        return "cancel";
      case 6:
        return "cancel";
      default:
        return "";
    }
  };

  const handleChange = (e, id) => {
    setDescriptions((prev) => ({
      ...prev,
      [id]: e.target.value,
    }));
  };

  const handleKeyDown = async (e, id, originalValue) => {
    const newValue = e.target.value;

    // No hagas nada si no cambió
    if (newValue === originalValue) return;

    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard/description_inspection/${id}`,
        {
          description: e.target.value,
          user_id: `${localStorage.getItem("light-load-email")}`,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleTypeShipment = async (e, id) => {
    const type = e.target.value;
    e.target.blur();
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard/inspection_type/${id}`,
        {
          type: parseInt(type),
          user_id: `${localStorage.getItem("light-load-email")}`,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setShipments((prev) =>
          prev.map((item) =>
            item.id === id ? { ...item, inspection_type: parseInt(type) } : item
          )
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getTypeShipments = (type) => {
    switch (type) {
      case 1:
        return "RX";
      case 2:
        return "ETD";
      case 3:
        return "Manual";
      default:
        return "";
    }
  };

  const finishInspection = async (id, value) => {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard/status_inspection/${id}`,
        {
          status: parseInt(value),
          user_id: `${localStorage.getItem("light-load-email")}`,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setShipments((prev) =>
          prev.map((item) =>
            item.id === id
              ? { ...item, inspection_status: parseInt(value) }
              : item
          )
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getInpectionTextShipments = (type) => {
    switch (type) {
      case 0:
        return "Incorrecto";
      case 1:
        return "Correcto";
      default:
        return "";
    }
  };

  const handleModalClick = (event) => {
    event.stopPropagation();
  };

  const formatDateWS = (dateString) => {
    setLoaderModal(true);
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleExportForm = async (data) => {
    const { startDate, endDate } = data;
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffInMs = end - start;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    try {
      if (diffInDays > 7) {
        setAlertDays(true);
        return;
      }
      setAlertDays(false);
      const formattedStart = formatDateWS(startDate);
      const formattedEnd = formatDateWS(endDate);

      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard?startDate=${formattedStart}&finishDate=${formattedEnd}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
        },
      });

      const transformShipments = response.data.shipments.map((item) => ({
        "# de turno": item.turn_number,
        "# de embarque": item.tag_number,
        "Hora emisión": item.created_at,
        "# de guía": item.awb ? item.awb : "-",
        description: item.merchandise_description,
        Observaciones: item.inspection_description,
        Destino: item.destination,
        Piezas: item.pieces,
        "Tipo de inspección": getTypeShipments(item.inspection_type) || "-",
        Estatus: item.status ? getStatusText(item.status) : "-",
        inspección: item.inspection_status
          ? getInpectionTextShipments(item.inspection_status)
          : "-",
      }));

      await generateExcelExport(
        transformShipments,
        formattedStart,
        formattedEnd
      );
      setLoaderModal(false);
      setStatusModal(false);
      resetForm2();
      setAlertDays(false);
    } catch (error) {
      setLoaderModal(false);
      setStatusModal(false);
      resetForm2();
      setAlertDays(false);
      Swal.fire({
        title: "Error",
        text: "Error al exportar, intentelo de nuevo más tarde",
        icon: "error",
      });
    }
  };

  const generateExcelExport = async (data, startDate, endDate) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Inspector");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(blob, `inspector-${startDate}-${endDate}.xlsx`);
  };

  useEffect(() => {
    const container = containerRef.current;
    if (!isFiltering && container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, [hasMore, isFiltering]);

  useEffect(() => {
    if (!isFiltering) {
      getData();
    }
  }, [page]);

  const renderExportModal = () => {
    return (
      <div className="inspector-modal" onClick={handleModalClick}>
        <div className="kpi-header-modal">
          <h4>Exportar</h4>
          <FaX
            style={{ color: "#dc0f38", cursor: "pointer" }}
            onClick={() => {
              setStatusModal(false);
              resetForm2();
              setAlertDays(false);
            }}
          />
        </div>

        {!loaderModal ? (
          <div className="inspector-body-modal">
            <form
              id="exportExcel"
              className="formRenderExport"
              onSubmit={handleSubmitForm2(handleExportForm)}
            >
              <div className="exportFormContent">
                <label>Fecha Inicio</label>
                <input
                  type="date"
                  {...registerForm2("startDate", {
                    required: "Este campo es obligatorio",
                    onChange: () => setAlertDays(false),
                  })}
                />
                {errorsForm2.startDate && (
                  <p className="errorExport">{errorsForm2.startDate.message}</p>
                )}
              </div>

              <div className="exportFormContent">
                <label>Fecha Final</label>
                <input
                  type="date"
                  {...registerForm2("endDate", {
                    required: "Este campo es obligatorio",
                    onChange: () => setAlertDays(false),
                  })}
                />
                {errorsForm2.endDate && (
                  <p className="errorExport">{errorsForm2.endDate.message}</p>
                )}
              </div>

              <button type="submit" form="exportExcel">
                Exportar
              </button>
            </form>

            {alertDays && (
              <div className="alertdays">
                <p>El rango de fecha tiene que ser menor a 7 días</p>
              </div>
            )}
          </div>
        ) : (
          <div className="modal-container">
            <span class="loader-inspector"></span>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    const subscription = watch((value) => {
      setFormValues({
        start: value.start || "",
        end: value.end || "",
        turn: value.turn || "",
        awb: value.awb || "",
      });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <>
      <div className="weighing-container">
        <Header />
        <div className="body-weighing">
          <div className="title-body-weighing">
            <h4>Inspección</h4>
          </div>

          <div className="table-container" ref={containerRef}>
            <div className="actions-container">
              <form onSubmit={handleSubmitForm1(onSubmit)}>
                <div className="inputs-con">
                  <div className="input-ind">
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class={`form-control ${
                          errors.turn ? "is-invalid" : ""
                        }`}
                        id="turn"
                        name="turn"
                        placeholder="Turno"
                        {...register("turn", {
                          pattern: {
                            value: /^[0-9]+$/,
                            message: "Solo se permiten números",
                          },
                        })}
                        ref={(e) => {
                          register("turn").ref(e);
                          turnRef.current = e;
                        }}
                        onFocus={() =>
                          setShowOverlay((prev) => ({ ...prev, turn: true }))
                        }
                        onBlur={() =>
                          setShowOverlay((prev) => ({ ...prev, turn: false }))
                        }
                      />
                      <label for="turn">Turno</label>
                      <Overlay
                        target={turnRef.current}
                        show={!!errors.turn && showOverlay.turn}
                        placement="top"
                      >
                        {(props) => (
                          <div
                            {...props}
                            style={{
                              backgroundColor: "rgba(255, 0, 0, 0.85)",
                              padding: "5px 10px",
                              color: "white",
                              borderRadius: 4,
                              fontSize: 12,
                              zIndex: 9999,
                              marginBottom: "10px",
                              ...props.style,
                            }}
                          >
                            {errors.turn?.message}
                          </div>
                        )}
                      </Overlay>
                    </div>
                  </div>
                  <div className="input-ind">
                    <div class="form-floating mb-3">
                      <input
                        type="date"
                        class={`form-control ${
                          errors.start ? "is-invalid" : ""
                        }`}
                        id="start"
                        name="start"
                        placeholder="Fecha inicio"
                        {...register("start", {
                          required: "Selecciona una fecha de inicio",
                          validate: (value) => {
                            if (
                              start &&
                              end &&
                              new Date(value) > new Date(end)
                            ) {
                              return "La fecha de inicio no puede ser mayor que la de fin";
                            }
                            return true;
                          },
                        })}
                        ref={(e) => {
                          register("start").ref(e);
                          startRef.current = e;
                        }}
                        onFocus={() =>
                          setShowOverlay((prev) => ({ ...prev, start: true }))
                        }
                        onBlur={() =>
                          setShowOverlay((prev) => ({ ...prev, start: false }))
                        }
                      />
                      <label for="start">Fecha inicio</label>
                      <Overlay
                        target={startRef.current}
                        show={!!errors.start && showOverlay.start}
                        placement="top"
                      >
                        {(props) => (
                          <div
                            {...props}
                            style={{
                              backgroundColor: "rgba(255, 0, 0, 0.85)",
                              padding: "5px 10px",
                              color: "white",
                              borderRadius: 4,
                              fontSize: 12,
                              zIndex: 9999,
                              marginBottom: "10px",
                              ...props.style,
                            }}
                          >
                            {errors.start?.message}
                          </div>
                        )}
                      </Overlay>
                    </div>
                  </div>
                  <div className="input-ind">
                    <div class="form-floating mb-3">
                      <input
                        type="date"
                        class={`form-control ${errors.end ? "is-invalid" : ""}`}
                        id="end"
                        name="end"
                        placeholder="Fecha fin"
                        {...register("end", {
                          required: "Selecciona una fecha de fin",
                        })}
                        ref={(e) => {
                          register("end").ref(e);
                          endRef.current = e;
                        }}
                        onFocus={() =>
                          setShowOverlay((prev) => ({ ...prev, end: true }))
                        }
                        onBlur={() =>
                          setShowOverlay((prev) => ({ ...prev, end: false }))
                        }
                      />
                      <label for="floatingInput">Fecha fin</label>
                      <Overlay
                        target={endRef.current}
                        show={!!errors.end && showOverlay.end}
                        placement="top"
                      >
                        {(props) => (
                          <div
                            {...props}
                            style={{
                              backgroundColor: "rgba(255, 0, 0, 0.85)",
                              padding: "5px 10px",
                              color: "white",
                              borderRadius: 4,
                              fontSize: 12,
                              zIndex: 9999,
                              marginBottom: "10px",
                              ...props.style,
                            }}
                          >
                            {errors.end?.message}
                          </div>
                        )}
                      </Overlay>
                    </div>
                  </div>
                </div>
                <div className="buttons-con">
                  <button
                    type="submit"
                    className="btn_filter"
                    id="btn_filter"
                    disabled={
                      !formValues.start || !formValues.end || !formValues.turn
                    }
                  >
                    Filtrar
                  </button>
                  <button
                    type="button"
                    className="dlt_filter"
                    id="dlt_filter"
                    onClick={clearFilters}
                  >
                    Borrar filtros
                  </button>
                  <button
                    type="button"
                    className="export_btn"
                    onClick={() => setStatusModal(true)}
                  >
                    Exportar
                  </button>
                </div>
              </form>
            </div>
            <table>
              <thead>
                <tr>
                  <th># Turno</th>
                  <th># Embarque</th>
                  <th>Hora emisión</th>
                  <th># Guía</th>
                  <th>Descripción</th>
                  <th>Observaciones</th>
                  <th>Destino</th>
                  <th>Piezas</th>
                  <th>Tipo de inspección</th>
                  <th>Estatus</th>
                  <th>inspección</th>
                </tr>
              </thead>

              <tbody>
                {shipments.map((row, index) => (
                  <tr
                    key={index}
                    style={{
                      background:
                        index % 2 === 0 ? "FFFFFF" : "rgba(213, 212, 212, 1)",
                    }}
                  >
                    <td>{row.turn_number ? row.turn_number : "-"}</td>
                    <td>{row.tag_number ? row.tag_number : "-"}</td>
                    <td>{row.created_at ? row.created_at : "-"}</td>
                    <td>{row.awb ? row.awb : "-"}</td>
                    <td>
                      {row.merchandise_description
                        ? row.merchandise_description
                        : "-"}
                    </td>
                    <td style={{ padding: 0 }}>
                      <textarea
                        className="observations"
                        value={
                          descriptions[row.id] ??
                          row.inspection_description ??
                          ""
                        }
                        onChange={(e) => handleChange(e, row.id)}
                        onBlur={(e) =>
                          handleKeyDown(e, row.id, row.inspection_description)
                        }
                        defaultValue={row?.inspection_description}
                        disabled={"inspection_status" in row}
                        readOnly={"inspection_status" in row}
                      ></textarea>
                    </td>
                    <td>{row.destination ? row.destination : "-"}</td>
                    <td>{row.pieces ? row.pieces : "-"}</td>
                    <td style={{ padding: 0 }}>
                      {"inspection_status" in row ? (
                        getTypeShipments(row.inspection_type)
                      ) : (
                        <select
                          className="inspection"
                          name="inspection"
                          id="inspection"
                          value={row.inspection_type ?? 1}
                          onChange={(e) => handleTypeShipment(e, row.id)}
                        >
                          <option value={1}>RX</option>
                          <option value={2}>ETD</option>
                          <option value={3}>Manual</option>
                        </select>
                      )}
                    </td>
                    <td>
                      <span className={`status ${getStatusClass(row?.status)}`}>
                        {row.status ? getStatusText(row.status) : "-"}
                      </span>
                    </td>
                    <td>
                      {"inspection_status" in row ? (
                        getInpectionTextShipments(row.inspection_status)
                      ) : (
                        <div className="actions">
                          <button
                            className="check-btn"
                            onClick={() => finishInspection(row.id, 1)}
                          >
                            <img
                              src={GenIcon}
                              alt="check"
                              style={{ width: "20px", height: "20px" }}
                            />
                          </button>
                          <button
                            className="no-check-btn"
                            onClick={() => finishInspection(row.id, 0)}
                          >
                            <img
                              src={NoCheckIcon}
                              alt="no Check"
                              style={{ width: "20px", height: "20px" }}
                            />
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div
          className={`kpi-modal-bg ${statusModal ? "active" : ""}`}
          onClick={() => {
            setStatusModal(false);
            resetForm2();
            setAlertDays(false);
          }}
        >
          {statusModal && renderExportModal()}
        </div>
      </div>
    </>
  );
}

export default WeighingControl;
